
import { TranslateResult } from 'vue-i18n';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Overview extends Vue {
  get cards(): {
    title: TranslateResult;
    text: TranslateResult;
    icon: string;
    route: string;
  }[] {
    return [
      {
        title: this.$t('context.overviewPage.cards.driver.title'),
        text: this.$t('context.overviewPage.cards.driver.text'),
        icon: 'Lightning',
        route: 'ContextDrivers',
      },
      {
        title: this.$t('context.overviewPage.cards.results.title'),
        text: this.$t('context.overviewPage.cards.results.text'),
        icon: 'ClipBoard',
        route: 'ContextResultTypes',
      },
      {
        title: this.$t('context.overviewPage.cards.scenarios.title'),
        text: this.$t('context.overviewPage.cards.scenarios.text'),
        icon: 'PlayButton',
        route: 'ContextScenarios',
      },
      {
        title: this.$t('context.overviewPage.cards.sectors.title'),
        text: this.$t('context.overviewPage.cards.sectors.text'),
        icon: 'Compass',
        route: 'ContextSectors',
      },
    ];
  }
}
